<template>
  <table id="properties-table">
    <thead>
      <tr>
        <th>Hotel</th>
        <th>Brand</th>
        <th>Destination</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in data" :key="index">
        <td>
          <a :href="item.url" class="link-3" target="_blank">{{ item.property }}</a>
        </td>
        <td>{{ item.brandCode }}</td>
        <td>{{ item.city }}, {{ item.country }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import originalData from '../json/luxury-experience-rate-properties.json';
import DataTable from 'datatables.net-dt';
import { ref, onMounted } from 'vue';

onMounted(() => {
  let table = new DataTable('#properties-table', {
    pageLength: 50,
    lengthMenu: [25, 50, 100],
    language: {
      search: '',
      searchPlaceholder: 'Search by Hotel, Brand, or Destination',
      entries: 'Results',
    },
  });
});

let data = ref([]);

originalData.forEach(item => {
  switch (item['B-Acro']) {
    case 'LC':
      item['B-Acro'] = 'Luxury Collection';
      break;
    case 'RITZ':
      item['B-Acro'] = 'Ritz-Carlton';
      break;
    case 'BHR':
      item['B-Acro'] = 'Bulgari';
      break;
    case 'ED':
      item['B-Acro'] = 'Edition';
      break;
    case 'MHR (JW)':
      item['B-Acro'] = 'JW Marriott';
      break;
    case 'RCC':
      item['B-Acro'] = 'Ritz-Carlton Club';
      break;
    case 'SR':
      item['B-Acro'] = 'St. Regis';
      break;
    case 'W':
      item['B-Acro'] = 'W Hotels';
      break;
    default:
      '';
  }

  let url;

  if (item['URL'] && item['URL'] !== '') {
    url = item['URL'];
  } else {
    url = `https://marriott.com/${item['MARSHA']}`;
  }

  data.value.push({
    brandCode: item['B-Acro'],
    property: item['Property Name'],
    city: item['City'],
    country: item['Country-Region'],
    url,
  })
});
</script>
